import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export const PageHero = ({ eyebrow, title, sub, image, children }) => (
  <section className="relative bg-navy text-paper pt-[140px] pb-20 sm:pb-28 overflow-hidden grain" data-testid="page-hero">
    {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />}
    <div className="absolute inset-0 bg-gradient-to-b from-navy/40 to-navy" />
    <div className="container-x relative">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h1 className="mt-5 max-w-4xl text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05] tracking-tight">{title}</h1>
      {sub && <p className="mt-6 max-w-2xl text-base md:text-lg text-paper/75 leading-relaxed">{sub}</p>}
      {children}
    </div>
  </section>
);

export const SectionHead = ({ eyebrow, title, sub, light = false }) => (
  <div className="max-w-3xl">
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2 className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-medium leading-[1.08] tracking-tight ${light ? "text-paper" : "text-navy"}`}>{title}</h2>
    {sub && <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-paper/70" : "text-ink/70"}`}>{sub}</p>}
  </div>
);

export const Disclaimer = ({ children, testid = "disclaimer" }) => (
  <div className="flex gap-3 border border-navy/15 bg-white p-5 text-[13px] leading-relaxed text-ink/70" data-testid={testid}>
    <ShieldAlert className="h-5 w-5 shrink-0 text-gold" />
    <p>
      {children ||
        "Information may come from third parties, including sellers, and has not been independently verified. Financial figures labeled Projected, Estimated or Provided by Seller are not guarantees. Sido Holdings does not guarantee investment returns; past performance does not guarantee future results. Investors should perform independent due diligence. Opportunities are subject to availability and transaction conditions."}{" "}
      <Link to="/legal/risk-disclosures" className="underline underline-offset-2 hover:text-navy">Risk disclosures</Link>
    </p>
  </div>
);

export const Chips = ({ options, value, onChange, multi = true, testid }) => (
  <div className="flex flex-wrap gap-2" data-testid={testid}>
    {options.map((o) => {
      const active = multi ? value.includes(o) : value === o;
      const toggle = () => onChange(multi ? (active ? value.filter((x) => x !== o) : [...value, o]) : o);
      return (
        <button
          type="button"
          key={o}
          onClick={toggle}
          data-testid={`${testid}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`px-4 py-3 text-sm border transition-[background-color,border-color,color] duration-200 ${active ? "bg-navy text-paper border-navy" : "bg-white text-navy border-navy/15 hover:border-navy/40"}`}
        >
          {o}
        </button>
      );
    })}
  </div>
);

export const Field = ({ label, hint, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="label">{label}</span>
    {children}
    {hint && <span className="mt-1.5 block text-xs text-mist">{hint}</span>}
  </label>
);
